/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import PropTypes from 'prop-types';

import React from 'react';
import * as analytics from 'analytics/Analytics';

class Carousel {
  constructor(el, intervalTimeout) {
    this.resetInterval = this.resetInterval.bind(this);
    this.$el = $(el);
    this.offset = 0;
    this.total = this.getChildren().length;
    this.intervalTimeout = intervalTimeout;
    this.resetInterval();
    this.$indicator = $('<div class="carouselIndicator u-pointer"></div>');
    for (let count = 0, end = this.total; count < end; count++) {
      this.$indicator.append(
        $('<div></div>')
          .toggleClass('active', count === 0)
          .click((e) => {
            const targetIndex = $(e.target).index();
            this.rotate(targetIndex);
            this.resetInterval();
          })
      );
    }
    this.$el.append(this.$indicator);
  }

  getChildren() {
    return this.$el.find('.land-carouselWrapper').children();
  }

  resetInterval() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(this.rotate.bind(this), this.intervalTimeout);
  }

  rotate(offset) {
    this.offset = offset != null ? offset : (this.offset + 1) % this.total;
    this.getChildren()
      .eq(0)
      .css({marginLeft: `${this.offset * -100}%`});
    this.$indicator.children().each((i, el) => $(el).toggleClass('active', i === this.offset));
  }

  stop() {
    clearInterval(this.interval);
    this.$indicator.remove();
  }
}

class ScrollTrigger {
  constructor() {
    this.scrollHandler = this.scrollHandler.bind(this);
    this.$els = $(document).find('.scrollTrigger');
    $(window).on('scroll.scrollTrigger', this.scrollHandler);
    $(window).on('resize.scrollTrigger', this.scrollHandler);
    this.$els.addClass('scrollHidden');
    this.scrollHandler();
  }

  scrollHandler() {
    const scrollTop = $(document).scrollTop();
    const lower = scrollTop + $(window).height() - 100;
    this.$els.each(function () {
      if (!$(this).hasClass('scrollHidden')) {
        return;
      }
      if ($(this).offset().top > lower) {
        return;
      }
      $(this).removeClass('scrollHidden');
    });
  }

  stop() {
    $(window).off('.scrollTrigger');
  }
}

export default class LandingViewEnhancements extends React.Component {
  static propTypes = {
    carouselInterval: PropTypes.number.isRequired,
  };

  static defaultProps = {carouselInterval: 5000};

  componentDidMount() {
    this.scrollTrigger = new ScrollTrigger();
    const {carouselInterval} = this.props;
    this.carousels = $('.land-carousel').map(function () {
      return new Carousel(this, carouselInterval);
    });
    // Demo link always opens new tab so we do not need to worry about the browser leaving the page and the
    // XHR getting lost (see dicussion in D2504)
    $('.requestDemoLink').click(() => {
      analytics.track('homepage', 'clicked_request_demo_link');
    });
  }

  componentWillUnmount() {
    this._stopCarousels();
    this.scrollTrigger.stop();
  }

  _stopCarousels() {
    return this.carousels.forEach((carousel) => carousel.stop());
  }

  render() {
    return null;
  }
}
